import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChatInmessageComponent } from './chat-inmessage/chat-inmessage.component';
import { CustomizationResolver } from './chat-inmessage/customization/shared/customization.resolver';

const routes: Routes = [
  {
    path: '',
    component: ChatInmessageComponent,
    children: [
      {
        path: 'customization',
        resolve: { page: () => inject(CustomizationResolver).resolve() },
        loadChildren: () =>
          import('./chat-inmessage/customization/customization.module').then(m => m.CustomizationModule),
      },
    ],
  },
  { path: '**', component: ChatInmessageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
